export enum ClaimReturnFollowupEnum {
  HOURS_24 = 24,
  HOURS_48 = 48,
  HOURS_72 = 72
}
